/* eslint-disable @typescript-eslint/no-explicit-any */
import { mpfRListsHttp } from '../api/mpf-r-lists-http'
import { isArchivedFilter } from './data'

interface ChecklistsListMetadata {
  Code: number
  Description: string
  IsArchived: boolean
  ItemCreated: Date
  ItemCreatedBy: any //Person_Single
  ItemModified: Date
  ItemModifiedBy: any //Person_Single
  Name: string
  URL: string
}
interface ChecklistsListMetadataArgs {
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: string
}
const COLUMN_NAMES = {
  Code: 'Code',
  Description: 'Description',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Name: 'Name',
  URL: 'URL',
}
const LIST_NAME = 'ChecklistsListMetadataList'
const getChecklistsListMetadata = async (
  args: ChecklistsListMetadataArgs
): Promise<ChecklistsListMetadata[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = isArchivedFilter(args.isArchivedFilter)
  const ascending = args?.isAscending ?? true
  const orderBy = args?.orderBy ?? COLUMN_NAMES.Code

  const items = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.Code,
      COLUMN_NAMES.Description,
      COLUMN_NAMES.IsArchived,
      COLUMN_NAMES.ItemCreated,
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.ItemModified,
      COLUMN_NAMES.ItemModifiedBy,
      COLUMN_NAMES.Name,
      COLUMN_NAMES.URL
    )
    .expand('ItemCreatedBy', 'ItemModifiedBy')
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()

  return [...items] as ChecklistsListMetadata[]
}
export {
  COLUMN_NAMES,
  type ChecklistsListMetadata,
  type ChecklistsListMetadataArgs,
  LIST_NAME,
  getChecklistsListMetadata,
}
